module.exports = __webpack_public_path__ + "img/5.f032f680.jpeg";